var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextjs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.2775,
    cy: 15.7978,
    r: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6546 11.774H13.4468V12.1685H9.09314V15.1447H13.1876V15.5393H9.09314V18.806H13.4966V19.2006H8.6546V11.774ZM13.8763 11.774H14.3857L16.6416 15.0407L18.9473 11.774L22.0849 7.62494L16.931 15.384L19.5863 19.2006H19.0573L16.6416 15.7273L14.2154 19.2006H13.6955L16.3719 15.384L13.8763 11.774ZM19.7762 12.1685V11.774H25.2375V12.1685H22.7208V19.2006H22.2823V12.1685H19.7762Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.65982 11.7739H3.20836L10.7795 23.5329L7.65097 19.2005L3.11794 12.3347L3.09835 19.2005H2.65982V11.7739Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1923 18.6864C25.2842 18.6864 25.3505 18.6149 25.3505 18.5217C25.3505 18.4285 25.2842 18.3555 25.1923 18.3555C25.1034 18.3555 25.0356 18.4285 25.0356 18.5217C25.0356 18.6149 25.1034 18.6864 25.1923 18.6864ZM25.6248 18.2514C25.6248 18.5264 25.8162 18.7066 26.095 18.7066C26.3919 18.7066 26.5712 18.5217 26.5712 18.1986V17.0662H26.3316V18.1986C26.3316 18.3773 26.2457 18.472 26.092 18.472C25.9564 18.472 25.8629 18.3835 25.8599 18.2514H25.6248ZM26.8847 18.2375C26.9012 18.5233 27.1318 18.7066 27.4724 18.7066C27.8386 18.7066 28.0676 18.514 28.0676 18.208C28.0676 17.9672 27.9365 17.8336 27.6201 17.7575L27.4513 17.714C27.2493 17.6643 27.168 17.599 27.168 17.4856C27.168 17.3412 27.2946 17.2464 27.4829 17.2464C27.6638 17.2464 27.7873 17.3381 27.8099 17.4856H28.042C28.0285 17.2169 27.7994 17.0258 27.4875 17.0258C27.1499 17.0258 26.9253 17.2169 26.9253 17.5012C26.9253 17.7373 27.0534 17.8771 27.3322 17.9454L27.5312 17.9951C27.7346 18.0449 27.825 18.1179 27.825 18.2406C27.825 18.3819 27.6834 18.486 27.4905 18.486C27.2855 18.486 27.1424 18.3897 27.1213 18.2375H26.8847Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextjs);
export default __webpack_public_path__ + "static/media/nextjs.7665cad0abd096a23b5568a62e64f932.svg";
export { ForwardRef as ReactComponent };